import { Component, OnInit } from '@angular/core';
import { TermsAndConditionsType } from '@fgb/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
@Component({
  selector: 'fgb-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss'],
})
export class TermsPageComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType.General;

  constructor(private navigationService: NavigationService) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
